/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfDirectoryResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfDirectoryResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /directories/{directory-id}/children
 */
export interface ChildrenRequestBuilder extends BaseRequestBuilder<ChildrenRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfDirectoryResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ChildrenRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfDirectoryResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ChildrenRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface ChildrenRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const ChildrenRequestBuilderUriTemplate = "{+baseurl}/directories/{directory%2Did}/children{?page*,pageSize*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ChildrenRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ChildrenRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfDirectoryResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
